'use strict';
var parent = require('../../es/instance/reverse');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/reverse.js
// module id = 767
// module chunks = 13